export const COUNTRIES = [
  { name: 'Afghanistan', code: 'AF' },
  { name: 'Åland Islands', code: 'AX' },
  { name: 'Albania', code: 'AL' },
  { name: 'Algeria', code: 'DZ' },
  { name: 'American Samoa', code: 'AS' },
  { name: 'AndorrA', code: 'AD' },
  { name: 'Angola', code: 'AO' },
  { name: 'Anguilla', code: 'AI' },
  { name: 'Antarctica', code: 'AQ' },
  { name: 'Antigua and Barbuda', code: 'AG' },
  { name: 'Argentina', code: 'AR' },
  { name: 'Armenia', code: 'AM' },
  { name: 'Aruba', code: 'AW' },
  { name: 'Australia', code: 'AU' },
  { name: 'Austria', code: 'AT' },
  { name: 'Azerbaijan', code: 'AZ' },
  { name: 'Bahamas', code: 'BS' },
  { name: 'Bahrain', code: 'BH' },
  { name: 'Bangladesh', code: 'BD' },
  { name: 'Barbados', code: 'BB' },
  { name: 'Belarus', code: 'BY' },
  { name: 'Belgium', code: 'BE' },
  { name: 'Belize', code: 'BZ' },
  { name: 'Benin', code: 'BJ' },
  { name: 'Bermuda', code: 'BM' },
  { name: 'Bhutan', code: 'BT' },
  { name: 'Bolivia', code: 'BO' },
  { name: 'Bosnia and Herzegovina', code: 'BA' },
  { name: 'Botswana', code: 'BW' },
  { name: 'Bouvet Island', code: 'BV' },
  { name: 'Brazil', code: 'BR' },
  { name: 'British Indian Ocean Territory', code: 'IO' },
  { name: 'Brunei Darussalam', code: 'BN' },
  { name: 'Bulgaria', code: 'BG' },
  { name: 'Burkina Faso', code: 'BF' },
  { name: 'Burundi', code: 'BI' },
  { name: 'Cambodia', code: 'KH' },
  { name: 'Cameroon', code: 'CM' },
  { name: 'Canada', code: 'CA' },
  { name: 'Cape Verde', code: 'CV' },
  { name: 'Cayman Islands', code: 'KY' },
  { name: 'Central African Republic', code: 'CF' },
  { name: 'Chad', code: 'TD' },
  { name: 'Chile', code: 'CL' },
  { name: 'China', code: 'CN' },
  { name: 'Christmas Island', code: 'CX' },
  { name: 'Cocos (Keeling) Islands', code: 'CC' },
  { name: 'Colombia', code: 'CO' },
  { name: 'Comoros', code: 'KM' },
  { name: 'Congo', code: 'CG' },
  { name: 'Congo, The Democratic Republic of the', code: 'CD' },
  { name: 'Cook Islands', code: 'CK' },
  { name: 'Costa Rica', code: 'CR' },
  { name: 'Cote D\'Ivoire', code: 'CI' },
  { name: 'Croatia', code: 'HR' },
  { name: 'Cuba', code: 'CU' },
  { name: 'Cyprus', code: 'CY' },
  { name: 'Czech Republic', code: 'CZ' },
  { name: 'Denmark', code: 'DK' },
  { name: 'Djibouti', code: 'DJ' },
  { name: 'Dominica', code: 'DM' },
  { name: 'Dominican Republic', code: 'DO' },
  { name: 'Ecuador', code: 'EC' },
  { name: 'Egypt', code: 'EG' },
  { name: 'El Salvador', code: 'SV' },
  { name: 'Equatorial Guinea', code: 'GQ' },
  { name: 'Eritrea', code: 'ER' },
  { name: 'Estonia', code: 'EE' },
  { name: 'Ethiopia', code: 'ET' },
  { name: 'Falkland Islands (Malvinas)', code: 'FK' },
  { name: 'Faroe Islands', code: 'FO' },
  { name: 'Fiji', code: 'FJ' },
  { name: 'Finland', code: 'FI' },
  { name: 'France', code: 'FR' },
  { name: 'French Guiana', code: 'GF' },
  { name: 'French Polynesia', code: 'PF' },
  { name: 'French Southern Territories', code: 'TF' },
  { name: 'Gabon', code: 'GA' },
  { name: 'Gambia', code: 'GM' },
  { name: 'Georgia', code: 'GE' },
  { name: 'Germany', code: 'DE' },
  { name: 'Ghana', code: 'GH' },
  { name: 'Gibraltar', code: 'GI' },
  { name: 'Greece', code: 'GR' },
  { name: 'Greenland', code: 'GL' },
  { name: 'Grenada', code: 'GD' },
  { name: 'Guadeloupe', code: 'GP' },
  { name: 'Guam', code: 'GU' },
  { name: 'Guatemala', code: 'GT' },
  { name: 'Guernsey', code: 'GG' },
  { name: 'Guinea', code: 'GN' },
  { name: 'Guinea-Bissau', code: 'GW' },
  { name: 'Guyana', code: 'GY' },
  { name: 'Haiti', code: 'HT' },
  { name: 'Heard Island and Mcdonald Islands', code: 'HM' },
  { name: 'Holy See (Vatican City State)', code: 'VA' },
  { name: 'Honduras', code: 'HN' },
  { name: 'Hong Kong', code: 'HK' },
  { name: 'Hungary', code: 'HU' },
  { name: 'Iceland', code: 'IS' },
  { name: 'India', code: 'IN' },
  { name: 'Indonesia', code: 'ID' },
  { name: 'Iran, Islamic Republic Of', code: 'IR' },
  { name: 'Iraq', code: 'IQ' },
  { name: 'Ireland', code: 'IE' },
  { name: 'Isle of Man', code: 'IM' },
  { name: 'Israel', code: 'IL' },
  { name: 'Italy', code: 'IT' },
  { name: 'Jamaica', code: 'JM' },
  { name: 'Japan', code: 'JP' },
  { name: 'Jersey', code: 'JE' },
  { name: 'Jordan', code: 'JO' },
  { name: 'Kazakhstan', code: 'KZ' },
  { name: 'Kenya', code: 'KE' },
  { name: 'Kiribati', code: 'KI' },
  { name: 'Korea, Democratic People\'S Republic of', code: 'KP' },
  { name: 'Korea, Republic of', code: 'KR' },
  { name: 'Kuwait', code: 'KW' },
  { name: 'Kyrgyzstan', code: 'KG' },
  { name: 'Lao People\'S Democratic Republic', code: 'LA' },
  { name: 'Latvia', code: 'LV' },
  { name: 'Lebanon', code: 'LB' },
  { name: 'Lesotho', code: 'LS' },
  { name: 'Liberia', code: 'LR' },
  { name: 'Libyan Arab Jamahiriya', code: 'LY' },
  { name: 'Liechtenstein', code: 'LI' },
  { name: 'Lithuania', code: 'LT' },
  { name: 'Luxembourg', code: 'LU' },
  { name: 'Macao', code: 'MO' },
  { name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK' },
  { name: 'Madagascar', code: 'MG' },
  { name: 'Malawi', code: 'MW' },
  { name: 'Malaysia', code: 'MY' },
  { name: 'Maldives', code: 'MV' },
  { name: 'Mali', code: 'ML' },
  { name: 'Malta', code: 'MT' },
  { name: 'Marshall Islands', code: 'MH' },
  { name: 'Martinique', code: 'MQ' },
  { name: 'Mauritania', code: 'MR' },
  { name: 'Mauritius', code: 'MU' },
  { name: 'Mayotte', code: 'YT' },
  { name: 'Mexico', code: 'MX' },
  { name: 'Micronesia, Federated States of', code: 'FM' },
  { name: 'Moldova, Republic of', code: 'MD' },
  { name: 'Monaco', code: 'MC' },
  { name: 'Mongolia', code: 'MN' },
  { name: 'Montserrat', code: 'MS' },
  { name: 'Morocco', code: 'MA' },
  { name: 'Mozambique', code: 'MZ' },
  { name: 'Myanmar', code: 'MM' },
  { name: 'Namibia', code: 'NA' },
  { name: 'Nauru', code: 'NR' },
  { name: 'Nepal', code: 'NP' },
  { name: 'Netherlands', code: 'NL' },
  { name: 'Netherlands Antilles', code: 'AN' },
  { name: 'New Caledonia', code: 'NC' },
  { name: 'New Zealand', code: 'NZ' },
  { name: 'Nicaragua', code: 'NI' },
  { name: 'Niger', code: 'NE' },
  { name: 'Nigeria', code: 'NG' },
  { name: 'Niue', code: 'NU' },
  { name: 'Norfolk Island', code: 'NF' },
  { name: 'Northern Mariana Islands', code: 'MP' },
  { name: 'Norway', code: 'NO' },
  { name: 'Oman', code: 'OM' },
  { name: 'Pakistan', code: 'PK' },
  { name: 'Palau', code: 'PW' },
  { name: 'Palestinian Territory, Occupied', code: 'PS' },
  { name: 'Panama', code: 'PA' },
  { name: 'Papua New Guinea', code: 'PG' },
  { name: 'Paraguay', code: 'PY' },
  { name: 'Peru', code: 'PE' },
  { name: 'Philippines', code: 'PH' },
  { name: 'Pitcairn', code: 'PN' },
  { name: 'Poland', code: 'PL' },
  { name: 'Portugal', code: 'PT' },
  { name: 'Puerto Rico', code: 'PR' },
  { name: 'Qatar', code: 'QA' },
  { name: 'Reunion', code: 'RE' },
  { name: 'Romania', code: 'RO' },
  { name: 'Russian Federation', code: 'RU' },
  { name: 'RWANDA', code: 'RW' },
  { name: 'Saint Helena', code: 'SH' },
  { name: 'Saint Kitts and Nevis', code: 'KN' },
  { name: 'Saint Lucia', code: 'LC' },
  { name: 'Saint Pierre and Miquelon', code: 'PM' },
  { name: 'Saint Vincent and the Grenadines', code: 'VC' },
  { name: 'Samoa', code: 'WS' },
  { name: 'San Marino', code: 'SM' },
  { name: 'Sao Tome and Principe', code: 'ST' },
  { name: 'Saudi Arabia', code: 'SA' },
  { name: 'Senegal', code: 'SN' },
  { name: 'Serbia and Montenegro', code: 'CS' },
  { name: 'Seychelles', code: 'SC' },
  { name: 'Sierra Leone', code: 'SL' },
  { name: 'Singapore', code: 'SG' },
  { name: 'Slovakia', code: 'SK' },
  { name: 'Slovenia', code: 'SI' },
  { name: 'Solomon Islands', code: 'SB' },
  { name: 'Somalia', code: 'SO' },
  { name: 'South Africa', code: 'ZA' },
  { name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
  { name: 'Spain', code: 'ES' },
  { name: 'Sri Lanka', code: 'LK' },
  { name: 'Sudan', code: 'SD' },
  { name: 'Suriname', code: 'SR' },
  { name: 'Svalbard and Jan Mayen', code: 'SJ' },
  { name: 'Swaziland', code: 'SZ' },
  { name: 'Sweden', code: 'SE' },
  { name: 'Switzerland', code: 'CH' },
  { name: 'Syrian Arab Republic', code: 'SY' },
  { name: 'Taiwan, Province of China', code: 'TW' },
  { name: 'Tajikistan', code: 'TJ' },
  { name: 'Tanzania, United Republic of', code: 'TZ' },
  { name: 'Thailand', code: 'TH' },
  { name: 'Timor-Leste', code: 'TL' },
  { name: 'Togo', code: 'TG' },
  { name: 'Tokelau', code: 'TK' },
  { name: 'Tonga', code: 'TO' },
  { name: 'Trinidad and Tobago', code: 'TT' },
  { name: 'Tunisia', code: 'TN' },
  { name: 'Turkey', code: 'TR' },
  { name: 'Turkmenistan', code: 'TM' },
  { name: 'Turks and Caicos Islands', code: 'TC' },
  { name: 'Tuvalu', code: 'TV' },
  { name: 'Uganda', code: 'UG' },
  { name: 'Ukraine', code: 'UA' },
  { name: 'United Arab Emirates', code: 'AE' },
  { name: 'United Kingdom', code: 'GB' },
  { name: 'United States', code: 'US' },
  { name: 'United States Minor Outlying Islands', code: 'UM' },
  { name: 'Uruguay', code: 'UY' },
  { name: 'Uzbekistan', code: 'UZ' },
  { name: 'Vanuatu', code: 'VU' },
  { name: 'Venezuela', code: 'VE' },
  { name: 'Viet Nam', code: 'VN' },
  { name: 'Virgin Islands, British', code: 'VG' },
  { name: 'Virgin Islands, U.S.', code: 'VI' },
  { name: 'Wallis and Futuna', code: 'WF' },
  { name: 'Western Sahara', code: 'EH' },
  { name: 'Yemen', code: 'YE' },
  { name: 'Zambia', code: 'ZM' },
  { name: 'Zimbabwe', code: 'ZW' }
];

export const STATES_PROVINCES = [
  {
    name: 'Alberta',
    code: 'AB'
  },
  {
    name: 'Alabama',
    code: 'AL'
  },
  {
    name: 'Alaska',
    code: 'AK'
  },
  {
    name: 'American Samoa',
    code: 'AS'
  },
  {
    name: 'Arizona',
    code: 'AZ'
  },
  {
    name: 'Arkansas',
    code: 'AR'
  },
  {
    name: 'British Columbia',
    code: 'BC'
  },
  {
    name: 'California',
    code: 'CA'
  },
  {
    name: 'Colorado',
    code: 'CO'
  },
  {
    name: 'Connecticut',
    code: 'CT'
  },
  {
    name: 'Delaware',
    code: 'DE'
  },
  {
    name: 'District Of Columbia',
    code: 'DC'
  },
  {
    name: 'Federated States Of Micronesia',
    code: 'FM'
  },
  {
    name: 'Florida',
    code: 'FL'
  },
  {
    name: 'Georgia',
    code: 'GA'
  },
  {
    name: 'Guam',
    code: 'GU'
  },
  {
    name: 'Hawaii',
    code: 'HI'
  },
  {
    name: 'Idaho',
    code: 'ID'
  },
  {
    name: 'Illinois',
    code: 'IL'
  },
  {
    name: 'Indiana',
    code: 'IN'
  },
  {
    name: 'Iowa',
    code: 'IA'
  },
  {
    name: 'Kansas',
    code: 'KS'
  },
  {
    name: 'Kentucky',
    code: 'KY'
  },
  {
    name: 'Louisiana',
    code: 'LA'
  },
  {
    name: 'Maine',
    code: 'ME'
  },
  {
    name: 'Manitoba',
    code: 'MB'
  },
  {
    name: 'Marshall Islands',
    code: 'MH'
  },
  {
    name: 'Maryland',
    code: 'MD'
  },
  {
    name: 'Massachusetts',
    code: 'MA'
  },
  {
    name: 'Michigan',
    code: 'MI'
  },
  {
    name: 'Minnesota',
    code: 'MN'
  },
  {
    name: 'Mississippi',
    code: 'MS'
  },
  {
    name: 'Missouri',
    code: 'MO'
  },
  {
    name: 'Montana',
    code: 'MT'
  },
  {
    name: 'Nebraska',
    code: 'NE'
  },
  {
    name: 'Nevada',
    code: 'NV'
  },
  {
    name: 'New Brunswick',
    code: 'NB'
  },
  {
    name: 'New Hampshire',
    code: 'NH'
  },
  {
    name: 'New Jersey',
    code: 'NJ'
  },
  {
    name: 'New Mexico',
    code: 'NM'
  },
  {
    name: 'New York',
    code: 'NY'
  },
  {
    name: 'Newfoundland and Labrador',
    code: 'NL'
  },
  {
    name: 'North Carolina',
    code: 'NC'
  },
  {
    name: 'North Dakota',
    code: 'ND'
  },
  {
    name: 'Northern Mariana Islands',
    code: 'MP'
  },
  {
    name: 'Nova Scotia',
    code: 'NS'
  },
  {
    name: 'Northwest Territories',
    code: 'NT'
  },
  {
    name: 'Nunavut',
    code: 'NU'
  },
  {
    name: 'Ohio',
    code: 'OH'
  },
  {
    name: 'Oklahoma',
    code: 'OK'
  },
  {
    name: 'Ontario',
    code: 'ON'
  },
  {
    name: 'Oregon',
    code: 'OR'
  },
  {
    name: 'Palau',
    code: 'PW'
  },
  {
    name: 'Pennsylvania',
    code: 'PA'
  },
  {
    name: 'Prince Edward Island',
    code: 'PE'
  },
  {
    name: 'Puerto Rico',
    code: 'PR'
  },
  {
    name: 'Quebec',
    code: 'QC'
  },
  {
    name: 'Rhode Island',
    code: 'RI'
  },
  {
    name: 'Saskatchewan',
    code: 'SK'
  },
  {
    name: 'South Carolina',
    code: 'SC'
  },
  {
    name: 'South Dakota',
    code: 'SD'
  },
  {
    name: 'Tennessee',
    code: 'TN'
  },
  {
    name: 'Texas',
    code: 'TX'
  },
  {
    name: 'Utah',
    code: 'UT'
  },
  {
    name: 'Vermont',
    code: 'VT'
  },
  {
    name: 'Virgin Islands',
    code: 'VI'
  },
  {
    name: 'Virginia',
    code: 'VA'
  },
  {
    name: 'Washington',
    code: 'WA'
  },
  {
    name: 'West Virginia',
    code: 'WV'
  },
  {
    name: 'Wisconsin',
    code: 'WI'
  },
  {
    name: 'Wyoming',
    code: 'WY'
  },
  {
    name: 'Yukon',
    code: 'YT'
  }
]


export const LOCALES = [
  {code: 'ach',  name: 'Lwo'},
  {code: 'ady',  name: 'Адыгэбзэ'},
  {code: 'af',  name: 'Afrikaans'},
  {code: 'af-NA',  name: 'Afrikaans (Namibia)'},
  {code: 'af-ZA',  name: 'Afrikaans (South Africa)'},
  {code: 'ak',  name: 'Tɕɥi'},
  {code: 'ar',  name: 'العربية'},
  {code: 'ar-AR',  name: 'العربية'},
  {code: 'ar-MA',  name: 'العربية'},
  {code: 'ar-SA',  name: 'العربية (السعودية)'},
  {code: 'ay-BO',  name: 'Aymar aru'},
  {code: 'az',  name: 'Azərbaycan dili'},
  {code: 'az-AZ',  name: 'Azərbaycan dili'},
  {code: 'be-BY',  name: 'Беларуская'},
  {code: 'bg',  name: 'Български'},
  {code: 'bg-BG',  name: 'Български'},
  {code: 'bn',  name: 'বাংলা'},
  {code: 'bn-IN',  name: 'বাংলা (ভারত)'},
  {code: 'bn-BD',  name: 'বাংলা(বাংলাদেশ)'},
  {code: 'bs-BA',  name: 'Bosanski'},
  {code: 'ca',  name: 'Català'},
  {code: 'ca-ES',  name: 'Català'},
  {code: 'cak',  name: 'Maya Kaqchikel'},
  {code: 'ck-US',  name: 'ᏣᎳᎩ (tsalagi)'},
  {code: 'cs',  name: 'Čeština'},
  {code: 'cs-CZ',  name: 'Čeština'},
  {code: 'cy',  name: 'Cymraeg'},
  {code: 'cy-GB',  name: 'Cymraeg'},
  {code: 'da',  name: 'Dansk'},
  {code: 'da-DK',  name: 'Dansk'},
  {code: 'de',  name: 'Deutsch'},
  {code: 'de-AT',  name: 'Deutsch (Österreich)'},
  {code: 'de-DE',  name: 'Deutsch (Deutschland)'},
  {code: 'de-CH',  name: 'Deutsch (Schweiz)'},
  {code: 'dsb',  name: 'Dolnoserbšćina'},
  {code: 'el',  name: 'Ελληνικά'},
  {code: 'el-GR',  name: 'Ελληνικά'},
  {code: 'en',  name: 'English'},
  {code: 'en-GB',  name: 'English (UK)'},
  {code: 'en-AU',  name: 'English (Australia)'},
  {code: 'en-CA',  name: 'English (Canada)'},
  {code: 'en-IE',  name: 'English (Ireland)'},
  {code: 'en-IN',  name: 'English (India)'},
  {code: 'en-PI',  name: 'English (Pirate)'},
  {code: 'en-UD',  name: 'English (Upside Down)'},
  {code: 'en-US',  name: 'English (US)'},
  {code: 'en-ZA',  name: 'English (South Africa)'},
  {code: 'en@pirate',  name: 'English (Pirate)'},
  {code: 'eo',  name: 'Esperanto'},
  {code: 'eo-EO',  name: 'Esperanto'},
  {code: 'es',  name: 'Español'},
  {code: 'es-AR',  name: 'Español (Argentine)'},
  {code: 'es-419',  name: 'Español (Latinoamérica)'},
  {code: 'es-CL',  name: 'Español (Chile)'},
  {code: 'es-CO',  name: 'Español (Colombia)'},
  {code: 'es-EC',  name: 'Español (Ecuador)'},
  {code: 'es-ES',  name: 'Español (España)'},
  {code: 'es-LA',  name: 'Español (Latinoamérica)'},
  {code: 'es-NI',  name: 'Español (Nicaragua)'},
  {code: 'es-MX',  name: 'Español (México)'},
  {code: 'es-US',  name: 'Español (Estados Unidos)'},
  {code: 'es-VE',  name: 'Español (Venezuela)'},
  {code: 'et',  name: 'eesti keel'},
  {code: 'et-EE',  name: 'Eesti (Estonia)'},
  {code: 'eu',  name: 'Euskara'},
  {code: 'eu-ES',  name: 'Euskara'},
  {code: 'fa',  name: 'فارسی'},
  {code: 'fa-IR',  name: 'فارسی'},
  {code: 'fb-LT',  name: 'Leet Speak'},
  {code: 'ff',  name: 'Fulah'},
  {code: 'fi',  name: 'Suomi'},
  {code: 'fi-FI',  name: 'Suomi'},
  {code: 'fo-FO',  name: 'Føroyskt'},
  {code: 'fr',  name: 'Français'},
  {code: 'fr-CA',  name: 'Français (Canada)'},
  {code: 'fr-FR',  name: 'Français (France)'},
  {code: 'fr-BE',  name: 'Français (Belgique)'},
  {code: 'fr-CH',  name: 'Français (Suisse)'},
  {code: 'fy-NL',  name: 'Frysk'},
  {code: 'ga',  name: 'Gaeilge'},
  {code: 'ga-IE',  name: 'Gaeilge (Gaelic)'},
  {code: 'gl',  name: 'Galego'},
  {code: 'gl-ES',  name: 'Galego'},
  {code: 'gn-PY',  name: 'Avañe\'ẽ'},
  {code: 'gu-IN',  name: 'ગુજરાતી'},
  {code: 'gx-GR',  name: 'Ἑλληνική ἀρχαία'},
  {code: 'he',  name: 'עברית‏'},
  {code: 'he-IL',  name: 'עברית‏'},
  {code: 'hi',  name: 'हिन्दी'},
  {code: 'hi-IN',  name: 'हिन्दी'},
  {code: 'hr',  name: 'Hrvatski'},
  {code: 'hr-HR',  name: 'Hrvatski'},
  {code: 'hsb',  name: 'Hornjoserbšćina'},
  {code: 'ht',  name: 'Kreyòl'},
  {code: 'hu',  name: 'Magyar'},
  {code: 'hu-HU',  name: 'Magyar'},
  {code: 'hy-AM',  name: 'Հայերեն'},
  {code: 'id',  name: 'Bahasa Indonesia'},
  {code: 'id-ID',  name: 'Bahasa Indonesia'},
  {code: 'is',  name: 'Íslenska'},
  {code: 'is-IS',  name: 'Íslenska (Iceland)'},
  {code: 'it',  name: 'Italiano'},
  {code: 'it-IT',  name: 'Italiano'},
  {code: 'ja',  name: '日本語'},
  {code: 'ja-JP',  name: '日本語'},
  {code: 'jv-ID',  name: 'Basa Jawa'},
  {code: 'ka-GE',  name: 'ქართული'},
  {code: 'kk-KZ',  name: 'Қазақша'},
  {code: 'km',  name: 'ភាសាខ្មែរ'},
  {code: 'km-KH',  name: 'ភាសាខ្មែរ'},
  {code: 'kab',  name: 'Taqbaylit'},
  {code: 'kn',  name: 'ಕನ್ನಡ'},
  {code: 'kn-IN',  name: 'ಕನ್ನಡ (India)'},
  {code: 'ko',  name: '한국어'},
  {code: 'ko-KR',  name: '한국어 (韩国)'},
  {code: 'ku-TR',  name: 'Kurdî'},
  {code: 'la',  name: 'Latin'},
  {code: 'la-VA',  name: 'Latin'},
  {code: 'lb',  name: 'Lëtzebuergesch'},
  {code: 'li-NL',  name: 'Lèmbörgs'},
  {code: 'lt',  name: 'Lietuvių'},
  {code: 'lt-LT',  name: 'Lietuvių'},
  {code: 'lv',  name: 'Latviešu'},
  {code: 'lv-LV',  name: 'Latviešu'},
  {code: 'mai',  name: 'मैथिली, মৈথিলী'},
  {code: 'mg-MG',  name: 'Malagasy'},
  {code: 'mk',  name: 'Македонски'},
  {code: 'mk-MK',  name: 'Македонски (Македонски)'},
  {code: 'ml',  name: 'മലയാളം'},
  {code: 'ml-IN',  name: 'മലയാളം'},
  {code: 'mn-MN',  name: 'Монгол'},
  {code: 'mr',  name: 'मराठी'},
  {code: 'mr-IN',  name: 'मराठी'},
  {code: 'ms',  name: 'Bahasa Melayu'},
  {code: 'ms-MY',  name: 'Bahasa Melayu'},
  {code: 'mt',  name: 'Malti'},
  {code: 'mt-MT',  name: 'Malti'},
  {code: 'my',  name: 'ဗမာစကာ'},
  {code: 'no',  name: 'Norsk'},
  {code: 'nb',  name: 'Norsk (bokmål)'},
  {code: 'nb-NO',  name: 'Norsk (bokmål)'},
  {code: 'ne',  name: 'नेपाली'},
  {code: 'ne-NP',  name: 'नेपाली'},
  {code: 'nl',  name: 'Nederlands'},
  {code: 'nl-BE',  name: 'Nederlands (België)'},
  {code: 'nl-NL',  name: 'Nederlands (Nederland)'},
  {code: 'nn-NO',  name: 'Norsk (nynorsk)'},
  {code: 'oc',  name: 'Occitan'},
  {code: 'or-IN',  name: 'ଓଡ଼ିଆ'},
  {code: 'pa',  name: 'ਪੰਜਾਬੀ'},
  {code: 'pa-IN',  name: 'ਪੰਜਾਬੀ (ਭਾਰਤ ਨੂੰ)'},
  {code: 'pl',  name: 'Polski'},
  {code: 'pl-PL',  name: 'Polski'},
  {code: 'ps-AF',  name: 'پښتو'},
  {code: 'pt',  name: 'Português'},
  {code: 'pt-BR',  name: 'Português (Brasil)'},
  {code: 'pt-PT',  name: 'Português (Portugal)'},
  {code: 'qu-PE',  name: 'Qhichwa'},
  {code: 'rm-CH',  name: 'Rumantsch'},
  {code: 'ro',  name: 'Română'},
  {code: 'ro-RO',  name: 'Română'},
  {code: 'ru',  name: 'Русский'},
  {code: 'ru-RU',  name: 'Русский'},
  {code: 'sa-IN',  name: 'संस्कृतम्'},
  {code: 'se-NO',  name: 'Davvisámegiella'},
  {code: 'si-LK',  name: 'පළාත'},
  {code: 'sk',  name: 'Slovenčina'},
  {code: 'sk-SK',  name: 'Slovenčina (Slovakia)'},
  {code: 'sl',  name: 'Slovenščina'},
  {code: 'sl-SI',  name: 'Slovenščina'},
  {code: 'so-SO',  name: 'Soomaaliga'},
  {code: 'sq',  name: 'Shqip'},
  {code: 'sq-AL',  name: 'Shqip'},
  {code: 'sr',  name: 'Српски'},
  {code: 'sr-RS',  name: 'Српски (Serbia)'},
  {code: 'su',  name: 'Basa Sunda'},
  {code: 'sv',  name: 'Svenska'},
  {code: 'sv-SE',  name: 'Svenska'},
  {code: 'sw',  name: 'Kiswahili'},
  {code: 'sw-KE',  name: 'Kiswahili'},
  {code: 'ta',  name: 'தமிழ்'},
  {code: 'ta-IN',  name: 'தமிழ்'},
  {code: 'te',  name: 'తెలుగు'},
  {code: 'te-IN',  name: 'తెలుగు'},
  {code: 'tg',  name: 'забо́ни тоҷикӣ́'},
  {code: 'tg-TJ',  name: 'тоҷикӣ'},
  {code: 'th',  name: 'ภาษาไทย'},
  {code: 'th-TH',  name: 'ภาษาไทย (ประเทศไทย)'},
  {code: 'tl',  name: 'Filipino'},
  {code: 'tl-PH',  name: 'Filipino'},
  {code: 'tlh',  name: 'tlhIngan-Hol'},
  {code: 'tr',  name: 'Türkçe'},
  {code: 'tr-TR',  name: 'Türkçe'},
  {code: 'tt-RU',  name: 'татарча'},
  {code: 'uk',  name: 'Українська'},
  {code: 'uk-UA',  name: 'Українська'},
  {code: 'ur',  name: 'اردو'},
  {code: 'ur-PK',  name: 'اردو'},
  {code: 'uz',  name: 'O\'zbek'},
  {code: 'uz-UZ',  name: 'O\'zbek'},
  {code: 'vi',  name: 'Tiếng Việt'},
  {code: 'vi-VN',  name: 'Tiếng Việt'},
  {code: 'xh-ZA',  name: 'isiXhosa'},
  {code: 'yi',  name: 'ייִדיש'},
  {code: 'yi-DE',  name: 'ייִדיש (German)'},
  {code: 'zh',  name: '中文'},
  {code: 'zh-Hans',  name: '中文简体'},
  {code: 'zh-Hant',  name: '中文繁體'},
  {code: 'zh-CN',  name: '中文（中国）'},
  {code: 'zh-HK',  name: '中文（香港）'},
  {code: 'zh-SG',  name: '中文（新加坡）'},
  {code: 'zh-TW',  name: '中文（台灣）'},
  {code: 'zu-ZA',  name: 'isiZulu'}
];